import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const LetsWorkSection = () => {
  return (
    <section id="lets-work" className="lets-work-section">
      <div className="lets-work-container">
        <div className="lets-work-content">
          <h2 className="lets-work-title">Let's work together</h2>
          <p className="lets-work-description">
            Ready to build adaptive intelligence into your organization?
            <br />
            We'd love to hear from you.
          </p>
          <div className="lets-work-cta">
            <a 
              href="https://outlook.office.com/bookwithme/user/4526d5f0831940e5bde7b640ab309b68%40idoconsulting.ca?anonymous&ismsaljsauthenabled=true" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Button className="lets-work-button">
                Get in Touch
                <ArrowRight size={20} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LetsWorkSection;
